<template>
  <a-modal
    :title="title"
    okText="保存"
    @ok="save"
    v-model="visible"
    :confirmLoading="confirmLoading"
  >
    <a-tree
      checkable
      v-model="checkedKeys"
      :treeData="treeData"
      v-if="treeData.length > 0"
    ></a-tree>
    <a-divider v-if="warning"></a-divider>
    <a-alert
      v-if="warning"
      message="修改自己的权限将重启应用"
      type="warning"
      showIcon
    />
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "AuthRoleModal",
  data() {
    return {
      title: "",
      record: {},
      treeData: [],
      checkedKeys: [],
      visible: false,
      confirmLoading: false,
      warning: false
    };
  },
  methods: {
    async save() {
      this.confirmLoading = true;
      try {
        await Api.system.updateRolePermission({
          role_id: this.record.id,
          permission_path: JSON.stringify(this.checkedKeys)
        });
        this.warning && location.reload();
        this.close();
      } catch (e) {}
      this.confirmLoading = false;
    },
    async show(record) {
      this.record = record;
      this.title = "权限设置-" + this.record.name;
      this.warning =
        this.record.id === this.$store.state.user.role_id ? true : false;
      let response;
      try {
        response = await Api.system.getPermissionTree();
      } catch (err) {
        if (err.message.cached) {
          response = err.message.data;
        }
      }
      this.treeData = response.list;
      let res = await Api.system.getRolePermission({ role_id: this.record.id });
      this.checkedKeys = res.permissions.map(item => item.permission_path);
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    onCheck(keys) {
      console.log("onCheck", keys);
    }
  }
};
</script>

<style scoped lang="scss"></style>
